import { Calculation, PaymentFrequency } from '@servicetitan/financing-api-client';
import { Divider, Flex } from '@servicetitan/anvil2';
import { Payment } from './Payment';

interface PromotionalProps {
    plan: Calculation;
    currentFrequency?: PaymentFrequency;
}
export const Promotional = ({ plan, currentFrequency }: PromotionalProps) => {
    return (
        <Flex style={{ width: '85%' }}>
            <Payment
                plan={plan}
                isPromoStart
                eyebrowText="Min. Payment"
                currentFrequency={currentFrequency}
            />
            <Divider vertical spacing="1" style={{ marginLeft: 'auto', marginRight: '1rem' }} />
            <Payment plan={plan} currentFrequency={currentFrequency} />
        </Flex>
    );
};
